import { render, staticRenderFns } from "./authenticationmt.vue?vue&type=template&id=db1cdb5e"
import script from "./authenticationmt.vue?vue&type=script&lang=js"
export * from "./authenticationmt.vue?vue&type=script&lang=js"
import style0 from "./authenticationmt.vue?vue&type=style&index=0&id=db1cdb5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports